module.exports = __webpack_public_path__ + "img/detective_with_closed_bag.1fe22161.png";